import { codeSplit } from 'bernie-core';

export const V2TabbedMapModuleMap = codeSplit(() => import(/* webpackChunkName: "V2InteractiveMapModuleMap" */ '../components/v2-tabbed-map-module') as any);